export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50];
